export default {
    'appConfig.label.preset-color': 'Color',
    'appConfig.label.surface-color': 'Surface',
    'appConfig.label.theme': 'Theme',
    'appConfig.label.menu-mode': 'Menu mode'
};
